// @ts-ignore
import("bootstrap")

import VConsole from "vconsole"
// 非生产环境添加调试工具vconsole
if (process.env.APP_ENV !== "production") {
	new VConsole()
}

